import React, { useEffect, useState } from "react";
import { AlertErrorMessage, AuthButton, Footer, Header } from "../Components";
import { useDispatch, useSelector } from "react-redux";
import { get, storeInLocalStorage } from "../Services/LocalStorageService";
import { useNavigate } from "react-router";
import axiosClient from "../AxiosClient";
import { loginSuccess } from "../Redux/SliceAuthUser";
import { Link } from "react-router-dom";
import "../Assets/Css/HomeCss/Login.css";
import FooterTopBar from "../Components/FooterTopBar";
import VerifiedEmailNotice from "../Components/Alert/VerifiedEmailNotice";
const Login = () => {
  document.title = "Login - Famra Cure";

  const userData = useSelector((state) => state.authUser);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData.isAuthenticated && get("TOKEN_USER")) {
      navigate("/user/profile");
    }
  }, [navigate, userData.isAuthenticated]);

  const [DataForm, setDataForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");

  const HandleChangeData = (ev) => {
    const { name, value } = ev.target;
    setDataForm({ ...DataForm, [name]: value });
  };

const HandleSubmit = (e) => {
  setError('');
  setLoading(true);
  e.preventDefault();

  axiosClient.post("/user/login", DataForm)
    .then((res) => {
      if (res.data.error) {
        setError(res.data.error);
      } else {
        if (res.statusText === "OK" || res.status === 200) {
          dispatch(loginSuccess(res.data.user));
          storeInLocalStorage("TOKEN_USER", res.data.token);

          // Redirect back to the intended page if one was stored (e.g. booking page)
          const redirectPath = sessionStorage.getItem("redirectAfterLogin");
          const redirectStateStr = sessionStorage.getItem("redirectAfterLoginState");
          if (redirectPath && res.data.user?.email_verified_at) {
            sessionStorage.removeItem("redirectAfterLogin");
            sessionStorage.removeItem("redirectAfterLoginState");
            const redirectState = redirectStateStr ? JSON.parse(redirectStateStr) : undefined;
            navigate(redirectPath, { state: redirectState });
          } else {
            navigate("/user/verifeyemail");
          }
        }
      }
    })
    .catch((error) => {
      const errorMessage = error?.response?.data?.message;
      if (error.toString().includes("Request failed with status code 422")) {
        setError("Invalid Credentials");
      } else if (errorMessage) {
        setError(errorMessage);
      } else {
        setError("Network error");
      }
    })
    .finally(() => {
      setLoading(false);
    })
  };

  // eslint-disable-next-line no-unused-vars
  const handleClose = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="h-screen">
        <div className=""

          style={{
            height: '810px',
            backgroundImage: "url('/img/login-Signup-Banner.jpg')",
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}

        >
          <Header />
          {/* Center the form */}
          <div className="h-[41rem] flex justify-center items-center">
            <div className="w-[27rem] rounded-md bg-white pl-8 pt-7 pr-8 pb-7"
              style={{
                position: 'relative',
                right: '20%',
                top: '0',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              }}>
              {/* Logo */}
              <div className="text-center mb-5">
                <h1 className="text-2xl font-semibold text-gray-900 mt-4">
                  Get Started <span className="text-[#3d75ba]">Now</span>
                </h1>
                <p className="text-sm text-slate-400 mt-2">
                  Enter your credential to access your account
                </p>
              </div>

              {/* Error Message */}
              <VerifiedEmailNotice />
              {error && <AlertErrorMessage message={error} />}

              {/* Form */}
              <form className="relative p-5 pl-8 pr-8 space-y-5" onSubmit={HandleSubmit}>
                <div className="mb-[20px]">
                  <label htmlFor="email" className="block mb-1 text-xs font-medium text-gray-900">
                    Email
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2 px-3"
                    placeholder="example@gmail.com"
                    required
                    onChange={HandleChangeData}
                  />
                </div>

                <div className="mb-[20px]">
                  <label htmlFor="Password" className="block mb-1 text-xs font-medium text-gray-900">
                    Password
                  </label>
                  <input
                    type="password"
                    id="Password"
                    name="password"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2 px-3"
                    placeholder="•••••••••"
                    required
                    onChange={HandleChangeData}
                  />
                </div>

                {/* Forgot Password */}
                <div className="mb-2">
                  <Link to="/forgot-password" className="flex flex-row-reverse">
                    <span className="text-medium tracking-wide text-[13px] text-blue-600">
                      Forgot your password?
                    </span>
                  </Link>
                </div>

                {/* Login Button */}
                <div className="flex justify-center items-center w-full">
                  <AuthButton Text="Login" Loading={loading} />
                </div>
              </form>

              {/* Sign Up & Doctor Login */}
              <div className="text-center mt-4">
                <p className="text-sm text-gray-500">
                  Don't have an account? <Link to="/user-signup" className="text-indigo-600 hover:underline">Sign Up</Link>
                </p>
                <p className="text-sm text-indigo-600 mt-2">
                  <Link to="/doctor/login">Are you a doctor?</Link>
                </p>
              </div>
            </div>
          </div>
          <FooterTopBar />
          <Footer colorText="white" />
        </div>
      </div>
    </>
  );
};

export default Login;
